export const paths = {
  collectPaymentWindowIsOpen: 'sale.collectPaymentWindow.isOpen',
  collectPaymentConfirmation: 'sale.collectPaymentWindow.confirmation',
  paymentUrlWindowIsOpen: 'sale.paymentUrlWindow.isOpen'
};
